module.exports = __webpack_public_path__ + "static/media/oppdal.54802682.jpg";